import { CheckIcon, RefreshIcon } from '@heroicons/react/solid'
import { useNavigate } from 'react-router-dom'
import {
  ErrorMissingData,
  ErrorNotLoggedIn,
  Form,
  Paragraph,
  StickyFooter,
  Title,
} from 'src/components'
import { savedTokens } from 'src/auth'
import { useTestSetup } from './queries'
import { savedUserGroup } from './storage'
import EmailHelpBox from 'src/components/Layout/EmailHelpBox'
import CustomButton from 'src/components/Shared/UIComponents/Button'
import { toast } from 'sonner'

type Props = {
  organization: string
  username: string
  userGroup: string
}

function TestSetup(props: Props) {
  const navigate = useNavigate()
  const testSetup = useTestSetup()

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault()
        testSetup.mutate(
          {
            organization: props.organization,
            username: props.username,
            usergroup: props.userGroup,
            usernamefortest: `mc_${props.organization}_test_setup_user`,
          },
          {
            onSuccess: (data) => {
              toast.success(`Ready to use Mobile Connect!`)
              navigate('../../')
            },
          },
        )
      }}
    >
      <Title label="Validate Setup" className="col-span-full" />

      <Paragraph className="col-span-full">
        We'll perform a test to check if everything looks ok
      </Paragraph>

      <Paragraph className="col-span-full">
        To enable contact searching you'll need to add the following{' '}
        <b>view permissions</b> to the <b>agent profile</b> in{' '}
        <b>Amazon Connect</b>
        <ul className="ml-4 list-disc">
          <li>Contact search</li>
          <li>Search contacts by keywords</li>
          <li>Contact attributes</li>
        </ul>
      </Paragraph>

      <StickyFooter>
        <EmailHelpBox className="flex-1" />
        <CustomButton
          type="submit"
          label="validate"
          loadingLabel="validating..."
          isLoading={testSetup.isLoading}
          icon={<CheckIcon />}
          iconPosition="left"
        />
      </StickyFooter>
    </Form>
  )
}

export default function ValidateTestSetup() {
  const navigate = useNavigate()
  const [tokens] = savedTokens.useState(null)
  const [userGroup] = savedUserGroup.useState('')

  if (!tokens) {
    return <ErrorNotLoggedIn />
  }

  if (!userGroup) {
    return (
      <ErrorMissingData
        missingValues={{
          userGroup: !userGroup,
        }}
      >
        <CustomButton
          label="restart setup"
          onClick={() => navigate('../arn')}
          className="ml-8"
          icon={<RefreshIcon />}
          iconPosition="left"
        />
      </ErrorMissingData>
    )
  }

  return (
    <TestSetup
      organization={tokens.organization}
      username={tokens.username}
      userGroup={userGroup}
    />
  )
}
